<div *ngIf="order" class="content-area">
  <div class="payment-section">
    <!-- Loading State - Shimmer -->
    <div *ngIf="state.isLoadingPaymentDetails" class="payment-loading-container">
      <h3 class="content-title">Payment Info</h3>
      <div class="payment-info-shimmer">
        <div class="shimmer-row">
          <div class="shimmer-col">
            <div class="shimmer-label"></div>
            <div class="shimmer-card-details">
              <div class="shimmer-icon"></div>
              <div class="shimmer-text"></div>
            </div>
            <div class="shimmer-text-small"></div>
          </div>
          <div class="shimmer-col">
            <div class="shimmer-label"></div>
            <div class="shimmer-text"></div>
          </div>
        </div>
        <div class="shimmer-row">
          <div class="shimmer-field">
            <div class="shimmer-label"></div>
            <div class="shimmer-text"></div>
          </div>
          <div class="shimmer-field">
            <div class="shimmer-label"></div>
            <div class="shimmer-text"></div>
          </div>
        </div>
      </div>
      <h3 class="content-title transaction-history-heading">Transaction History</h3>
      <div class="transaction-history-shimmer">
        <div class="shimmer-transaction-item">
          <div class="shimmer-text"></div>
          <div class="shimmer-text-small"></div>
        </div>
      </div>
    </div>

    <!-- Payment Info Card -->
    <ng-container *ngIf="!state.isLoadingPaymentDetails && hasCardDetails()">
      <h3 class="content-title">Payment Info</h3>
      <app-payment-info-card
        [brandIcon]="getCardBrandIcon()"
        [brandName]="getCardBrandName()"
        [cardMask]="getCardMask()"
        [dateTime]="getPaymentDate()"
        [transactionId]="getTransactionId()"
        [billingAddress]="getBillingAddress()"
        [contact]="getContactInfo()"
      >
      </app-payment-info-card>
    </ng-container>

    <!-- Payment Form - Shown when payment is pending -->
    <div *ngIf="isPaymentPending()" class="payment-form-section">
      <h3 class="content-title">Make Payment</h3>
      <div class="payment-form-container">
        <div class="scrollable-content">
          <!-- Payment Method Selection -->
          <div class="payment-methods" [class.compact]="state.showMorePaymentMethods">
            <!-- Tap to Pay — shown on all devices; disabled on desktop (matches notification checkout) -->
            <div
              class="payment-method"
              [class.selected]="state.paymentForm.method === PaymentMethodCode.TapToPay"
              [class.disabled]="!isMobileOrTablet"
              (click)="!isMobileOrTablet ? null : selectPaymentMethod(PaymentMethodCode.TapToPay)"
            >
              <div class="method-content">
                <div class="method-icon" *ngIf="!state.showMorePaymentMethods">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      fill="none"
                    />
                    <path
                      d="M6 10H18"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14Z"
                      fill="currentColor"
                    />
                    <path
                      d="M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
                      fill="currentColor"
                    />
                    <path
                      d="M16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12C15.4477 12 15 12.4477 15 13C15 13.5523 15.4477 14 16 14Z"
                      fill="currentColor"
                    />
                    <path
                      d="M19 7H5"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="method-info">
                  <div class="method-title">Tap to Pay</div>
                  <div class="method-description">Open the app to process payment</div>
                </div>
              </div>
              <div
                class="method-radio"
                [class.checked]="state.paymentForm.method === PaymentMethodCode.TapToPay"
              ></div>
            </div>

            <!-- Cash -->
            <div
              class="payment-method"
              [class.selected]="state.paymentForm.method === PaymentMethodCode.Cash"
              [class.disabled]="isCashPaymentDisabled()"
              (click)="!isCashPaymentDisabled() && selectPaymentMethod(PaymentMethodCode.Cash)"
            >
              <div class="method-content">
                <div class="method-icon" *ngIf="!state.showMorePaymentMethods">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.72-2.92-.01-1.56-1.19-2.45-3.61-3.01z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div class="method-info">
                  <div class="method-title">Cash</div>
                  <div class="method-description">Confirm cash payment received</div>
                </div>
              </div>
              <div
                class="method-radio"
                [class.checked]="state.paymentForm.method === PaymentMethodCode.Cash"
              ></div>
            </div>

            <!-- Card -->
            <div
              class="payment-method"
              [class.selected]="state.paymentForm.method === PaymentMethodCode.Card"
              (click)="selectPaymentMethod(PaymentMethodCode.Card)"
            >
              <div class="method-content">
                <div class="method-icon" *ngIf="!state.showMorePaymentMethods">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="3"
                      y="5"
                      width="18"
                      height="14"
                      rx="2"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="1.5" />
                  </svg>
                </div>
                <div class="method-info">
                  <div class="method-title">Card Payment</div>
                  <div class="method-description">Enter card details to make payment</div>
                </div>
              </div>
              <div
                class="method-radio"
                [class.checked]="state.paymentForm.method === PaymentMethodCode.Card"
              ></div>
            </div>

            <!-- Additional Methods (expanded) -->
            <div
              class="payment-method"
              *ngIf="state.showMorePaymentMethods"
              [class.selected]="state.paymentForm.method === PaymentMethodCode.Link"
              (click)="selectPaymentMethod(PaymentMethodCode.Link)"
            >
              <div class="method-content">
                <div class="method-icon" *ngIf="!state.showMorePaymentMethods">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="method-info">
                  <div class="method-title">Payment Link</div>
                  <div class="method-description">Send payment link to customer</div>
                </div>
              </div>
              <div
                class="method-radio"
                [class.checked]="state.paymentForm.method === PaymentMethodCode.Link"
              ></div>
            </div>

            <ng-container *ngIf="state.showMorePaymentMethods">
              <div
                class="payment-method"
                *ngFor="let method of filteredDynamicPaymentMethodOptions"
                [class.selected]="isDynamicPaymentMethodSelected(method.name)"
                (click)="selectPaymentMethod(method.name)"
              >
                <div class="method-content">
                  <div class="method-icon" *ngIf="!state.showMorePaymentMethods">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2L2 7L12 12L22 7L12 2Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 17L12 22L22 17"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 12L12 17L22 12"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="method-info">
                    <div class="method-title">{{ method.name }}</div>
                    <div class="method-description">Confirm payment using {{ method.name }}</div>
                  </div>
                </div>
                <div
                  class="method-radio"
                  [class.checked]="isDynamicPaymentMethodSelected(method.name)"
                ></div>
              </div>
            </ng-container>

            <!-- More/Less Toggle -->
            <div class="more-payment-methods-toggle" (click)="toggleMorePaymentMethods()">
              <span>{{
                state.showMorePaymentMethods ? 'Less Payment Methods' : 'More Payment Methods'
              }}</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [class.rotated]="state.showMorePaymentMethods"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <!-- Card Payment Form -->
          <div
            *ngIf="state.paymentForm.method === PaymentMethodCode.Card"
            class="card-payment-form"
          >
            <div class="stripe-form-container">
              <div class="form-row">
                <div class="form-field">
                  <label class="field-label">Name on card<span class="asterisk">*</span></label>
                  <div class="stripe-input-container">
                    <input
                      type="text"
                      class="stripe-input-field"
                      placeholder="e.g. John Smith"
                      autocomplete="cc-name"
                      [(ngModel)]="state.paymentForm.cardholderName"
                      name="cardholderName"
                    />
                  </div>
                </div>

                <div class="form-field">
                  <label class="field-label">Card number<span class="asterisk">*</span></label>
                  <div class="stripe-input-container">
                    <div id="card-number" class="stripe-input-field"></div>
                  </div>
                  <div id="card-number-error" class="field-error" role="alert"></div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label class="field-label">Expiration<span class="asterisk">*</span></label>
                  <div class="stripe-input-container">
                    <div id="card-expiry" class="stripe-input-field"></div>
                  </div>
                  <div id="card-expiry-error" class="field-error" role="alert"></div>
                </div>
                <div class="form-field">
                  <label class="field-label">CVC<span class="asterisk">*</span></label>
                  <div class="stripe-input-container">
                    <div id="card-cvc" class="stripe-input-field"></div>
                  </div>
                  <div id="card-cvc-error" class="field-error" role="alert"></div>
                </div>
              </div>

              <div class="form-field">
                <label class="field-label">Billing address</label>
                <div class="stripe-input-container">
                  <input
                    type="text"
                    class="stripe-input-field"
                    placeholder="e.g. 122B, Baker Street, NYC"
                    [(ngModel)]="state.paymentForm.billingAddress"
                    name="billingAddress"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Phone Number for Payment Link -->
          <div
            *ngIf="state.paymentForm.method === PaymentMethodCode.Link"
            class="phone-input-section"
          >
            <app-custom-input
              label="Phone Number"
              placeholder="e.g. (212) 555-1234"
              type="tel"
              inputMode="numeric"
              [required]="true"
              [validationRules]="paymentPhoneValidation"
              [showValidation]="true"
              [markTouchedOnInput]="true"
              [(value)]="state.paymentForm.phoneNumber"
            >
            </app-custom-input>
          </div>
        </div>

        <!-- Payment Actions -->
        <div class="payment-actions">
          <button class="cancel hide-cancel-mobile" (click)="$event.stopPropagation()">
            Cancel
          </button>
          <div class="footer-right">
            <button
              *ngIf="
                state.paymentForm.method !== PaymentMethodCode.Cash &&
                !isDynamicPaymentMethod(state.paymentForm.method)
              "
              class="send-link"
              type="button"
              [disabled]="
                state.paymentForm.method === PaymentMethodCode.TapToPay
                  ? false
                  : !isPaymentFormValid() ||
                    state.isProcessingPayment ||
                    state.isCreatingPaymentLink
              "
              (click)="
                state.paymentForm.method === PaymentMethodCode.TapToPay
                  ? openTapToPayApp()
                  : state.paymentForm.method === PaymentMethodCode.Card
                    ? processCardPayment()
                    : createPaymentLink()
              "
            >
              <span *ngIf="!state.isProcessingPayment && !state.isCreatingPaymentLink">
                {{
                  state.paymentForm.method === PaymentMethodCode.TapToPay
                    ? 'Proceed'
                    : state.paymentForm.method === PaymentMethodCode.Card
                      ? 'Checkout'
                      : 'Send Link'
                }}
              </span>
              <span *ngIf="state.isProcessingPayment" class="loading-content">
                <div class="loading-spinner"></div>
                Processing...
              </span>
              <span *ngIf="state.isCreatingPaymentLink" class="loading-content">
                <div class="loading-spinner"></div>
                Creating Link...
              </span>
            </button>
            <!-- Cash and Membership Confirmation -->
            <div
              *ngIf="
                state.paymentForm.method === PaymentMethodCode.Cash ||
                isDynamicPaymentMethod(state.paymentForm.method)
              "
              class="cash-payment-section"
            >
              <button
                class="send-link"
                [disabled]="state.isConfirmingCashPayment"
                (click)="confirmPaymentMode(state.paymentForm.method)"
              >
                <span *ngIf="!state.isConfirmingCashPayment">Confirm Payment</span>
                <span *ngIf="state.isConfirmingCashPayment" class="loading-content">
                  <div class="loading-spinner"></div>
                  Confirming...
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transaction History -->
    <h3
      class="content-title transaction-history-heading"
      *ngIf="!state.isLoadingPaymentDetails && !isPaymentPending()"
    >
      Transaction History
    </h3>
    <div
      class="transaction-history-list"
      *ngIf="!state.isLoadingPaymentDetails && !isPaymentPending()"
    >
      <ng-container *ngFor="let th of state.transactionHistories; trackBy: trackByIndex">
        <app-payment-transaction-card
          [date]="formatPaymentDate(th.payment_date)"
          [items]="getTransactionItems(th)"
          [totalLabel]="getTotalLabel(th)"
          [totalAmount]="getTotalAmountPaid(th)"
          [transactionData]="th"
          (downloadInvoice)="onDownloadInvoice($event)"
          (printInvoice)="onPrintInvoice($event)"
        >
        </app-payment-transaction-card>
      </ng-container>

      <ng-container *ngIf="hasOriginalOrderTransactionHistory()">
        <ng-container
          *ngFor="let th of state.originalOrderTransactionHistories; trackBy: trackByIndex"
        >
          <app-payment-transaction-card
            [date]="formatPaymentDate(th.payment_date)"
            [items]="getTransactionItems(th)"
            [totalLabel]="getTotalLabel(th)"
            [totalAmount]="getTotalAmountPaid(th)"
            [transactionData]="th"
            (downloadInvoice)="onDownloadOriginalOrderInvoice($event)"
            (printInvoice)="onPrintInvoice($event)"
          >
          </app-payment-transaction-card>
        </ng-container>
      </ng-container>

      <div
        *ngIf="
          state.transactionHistories.length === 0 &&
          !hasOriginalOrderTransactionHistory() &&
          !state.paymentDetailsError &&
          !isPaymentPending()
        "
        class="no-transaction-history"
      >
        <p>No transaction history</p>
      </div>

      <div *ngIf="state.paymentDetailsError && !isPaymentPending()" class="no-transaction-history">
        <p>Unable to load transaction history</p>
      </div>
    </div>
  </div>
</div>

<!-- Payment Link Sent Modal -->
<app-payment-link-sent-modal
  [isOpen]="state.showPaymentLinkSentModal"
  [phoneNumber]="state.paymentForm.phoneNumber"
  [isResending]="state.isCreatingPaymentLink"
  (close)="onPaymentLinkSentModalClose()"
  (cancelPayment)="onCancelPayment()"
  (resendLink)="onResendPaymentLink()"
>
</app-payment-link-sent-modal>
